import React from "react";

import s from "./PatientFileReference.module.css";

/*
 * The heading of a collapsible reference section. The badge is the whole point:
 * while the section is shut it is the only thing telling a GP whether there is
 * anything in there, so "none" is spelled out rather than left blank.
 */
export const ReferenceSectionTitle = ({ title, badge }) => (
  <span className={s.sectionTitle}>
    <span className={s.sectionName}>{title}</span>
    <span
      className={`${s.badge} ${
        badge.tone === "count" ? s.badgeCount : s.badgeMuted
      }`}
      data-testid={`reference-badge-${badge.tone}`}
    >
      {badge.text}
    </span>
  </span>
);
